<template>
    <div :class="companyCardClass" @mouseover="mouseOver" @mouseleave="mouseLeave" @click="avatarClick">
        <img :src="companyAvatar" :alt="$t('alt.company_avatar')" />

        <Transition>
            <div v-if="isHoverable" class="avatar__hover-text">{{ hoverText }}</div>
        </Transition>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        props: {
            size: { type: String, required: true },
            company: { type: Object, default: undefined },
            showOrginalImage: { type: Boolean, default: false },
            withBorder: { type: Boolean, default: false },
            hoverText: { type: String, default: null },
            shouldLeadToProfile: { type: Boolean, default: false },
        },

        data() {
            return {
                placeholderImage: require('../../../assets/images/company-placeholder.png'),
                isHovered: false,
            }
        },

        computed: {
            companyCardClass() {
                return {
                    'company-avatar': true,
                    'company-avatar__with-border': this.withBorder,
                    [`company-avatar--size-${this.size}`]: true,
                    avatar__hovered: this.isHoverable,
                    avatar__pointer: this.shouldLeadToProfile,
                }
            },

            companyAvatar() {
                return (this.showOrginalImage ? this.company?.photoMain : this.company?.photoAvatar) ?? this.placeholderImage
            },

            isHoverable() {
                return this.hoverText && this.isHovered
            },
        },

        methods: {
            mouseOver() {
                this.isHovered = true
            },

            mouseLeave() {
                this.isHovered = false
            },

            avatarClick() {
                if (this.shouldLeadToProfile) {
                    this.$router.push({
                        name: RoutesEnum.COMPANY.PROFILE,
                        params: { id: this.company.id, companyType: 'profile' },
                    })
                }
                this.emitEvent({ name: 'avatar-click' })
            },
        },
    }
</script>
